import { PUBLIC_URL } from '../env'

export const getPhenomenonUrl = (
  radarId = false,
  phenomenon,
  hideEdit = false,
) => {
  if (
    !!phenomenon &&
    !!phenomenon?.groups &&
    !!phenomenon?.groups?.length &&
    !phenomenon?.group
  ) {
    phenomenon['group'] = phenomenon?.groups[0]
  }
  const { group, id } = phenomenon
  const hasGroup = phenomenon.hasOwnProperty('group')
  const groupUrl = hasGroup ? `group=${group}` : ''

  if (!radarId) {
    return `/fp-phenomena/${id}${groupUrl.length ? `/?${groupUrl}` : ''}`
  }

  // eslint-disable-next-line
  return `/fp-phenomena/${id}${
    groupUrl.length ? `/?${groupUrl}` : ''
  }&radar=${radarId}&source_position=right&source_page=radar-view${
    groupUrl.length ? `&${groupUrl}` : ''
  }${hideEdit ? '&hideEdit=true' : ''}`
}
